import { useLanguage } from '@/i18n/LanguageContext';
import { motion } from 'framer-motion';
import { ExternalLink } from 'lucide-react';
import { Card, CardContent } from '@/components/ui/card';
import { useMediaMentions, getTranslation } from '@/hooks/useSupabaseData';
import { Skeleton } from '@/components/ui/skeleton';

const MediaMentionsSection = () => {
  const { t, lang } = useLanguage();
  const { data: mentions, isLoading } = useMediaMentions();
  const displayMentions = mentions?.slice(0, 4);

  return (
    <section className="py-20 bg-secondary/20">
      <div className="container mx-auto px-4">
        <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-gradient-gold mb-4">{t('section.media_title')}</h2>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {isLoading ? (
            Array.from({ length: 4 }).map((_, i) => <Skeleton key={i} className="h-40 rounded-xl" />)
          ) : displayMentions?.length ? (
            displayMentions.map((item, i) => {
              const tr = getTranslation(item.media_mention_translations, lang);
              return (
                <motion.div key={item.id} initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: i * 0.1 }}>
                  <a href={item.source_url || '#'} target="_blank" rel="noopener noreferrer">
                    <Card className="bg-card/50 border-border/50 hover:border-primary/30 transition-all h-full group cursor-pointer">
                      <CardContent className="p-6">
                        <div className="flex items-center justify-between mb-4">
                          {item.mention_date && <span className="text-xs text-muted-foreground">{item.mention_date}</span>}
                          <ExternalLink className="w-4 h-4 text-muted-foreground group-hover:text-primary transition-colors" />
                        </div>
                        <p className="text-sm font-semibold text-primary mb-2">{tr?.source_name || ''}</p>
                        <p className="text-sm text-foreground leading-relaxed">{tr?.title || ''}</p>
                      </CardContent>
                    </Card>
                  </a>
                </motion.div>
              );
            })
          ) : null}
        </div>
      </div>
    </section>
  );
};

export default MediaMentionsSection;
